exports.IDS = {
  // IMG_URL: "http://192.168.16.23:2007",
  IMG_URL: "http://node.khadyalay.profcyma.org:2007",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
  User: {
    Admin: 1,
    Shopkeeper: 2,
    Party: 3,
    Vendor: 4,
  },
};
